<template>
    <div class="exam-result-management">
        <h3>시스템 설정 > 접속 및 인증 정책 설정</h3>
        <div class="account-card-box">
            <div class="policy-panel">
                <!-- 로그인 실패 시 잠금 기준 설정 -->
                <div class="policy-group">
                    <div class="policy-label">로그인 실패 시 잠금 기준</div>
                    <div class="policy-row">
                        <div class="policy-label-sm">실패 횟수</div>
                        <input type="number" class="input" placeholder="ex. 5" v-model="failCount" min="1" max="20" />
                    </div>
                </div>

                <!-- 세션 타임아웃 설정 -->
                <div class="policy-group">
                    <div class="policy-label">세션 타임 아웃 설정</div>
                    <div class="policy-row">
                        <div class="policy-label-sm">세션 타임 아웃 시간</div>
                        <select class="input" v-model="timeout">
                            <option value="10">10 min</option>
                            <option value="20">20 min</option>
                            <option value="30">30 min</option>
                            <option value="60">60 min</option>
                        </select>
                    </div>
                </div>
            </div>

            <!-- 저장 버튼 -->
            <div class="btn-area">
                <button class="primary-btn" @click="save">저장</button>
            </div>
        </div>
    </div>
</template>

<script>
import api, {urls} from '@/api'

export default {
    data() {
        return {
            failCount : "",
            timeout : "",

        };
    },
    methods: {
        save() {
            api.post(urls.system.accessSave,
                {
                failCount: this.failCount,
                timeout: this.timeout,
            })
                .then((res) => {
                    const data = res.data;

                    if (data === 1) {
                        alert(`저장 성공: 실패횟수 ${this.failCount}, 세션타임아웃 ${this.timeout}분`);
                        // 필요 시 추가 후처리
                    } else {
                        this.error = data.message || '저장에 실패하였습니다.';
                        alert(this.error);
                    }
                })
                .catch((error) => {
                    alert('실패횟수, 세션타임 변경기능이 실패했습니다.');
                    console.error(error);
                });
        },

        getdate() {
            api.get(urls.system.accessData)
                .then((res) => {
                    const data = res.data.list[0];
                    this.failCount = data.failCount !== undefined ? Number(data.failCount) : "";
                    this.timeout = String(data.timeout || "");
                })
                .catch((error) => {
                    alert('실패횟수, 세션타임 변경기능이 실패했습니다.');
                    console.error(error);
                });
        },


    },
    mounted() {
        this.getdate();
    },
};
</script>

